<app-dialog-header [title]="headerTitle" [disabled]="isSaving"></app-dialog-header>

<mat-dialog-content>
  <div class="container modal-ticket" id="modalTicketBatch">
    @if (saveErrors.length) {
      <div class="schedule-errors p-3" role="alert" aria-live="polite">
        @for (error of saveErrors; track $index) { <p class="mb-1">{{ error }}</p> }
      </div>
    }
    @if (proposal) {
      <section class="p-3" aria-labelledby="scheduleProposalTitle">
        <h2 id="scheduleProposalTitle" class="h4 title">Revisar ajuste de datas</h2>
        <p>O novo término pode afetar os próximos lotes. Confira a comparação antes de confirmar.</p>
        <p class="text-secondary">O próximo lote começa no término do anterior. Por padrão, mantemos seu término quando possível; se não houver mais período de vendas, deslocamos o período original e verificamos os seguintes.</p>
        <label class="d-flex align-items-center gap-2 mb-3">
          <input type="checkbox" [checked]="preserveDuration" [disabled]="isSaving" (change)="changeDurationStrategy($event)">
          Preservar a duração original dos lotes seguintes (ajustar início e término)
        </label>
        <p class="text-secondary">Horário de Brasília. Nada foi salvo ainda.</p>
        <div class="schedule-comparison">
          @for (change of scheduleChanges; track change.batch_id) {
            <article class="schedule-card">
              <h3 class="h5">Lote {{ change.batch_number }} {{ change.batch_id === proposal.source.batch_id ? '— lote em edição' : '— ajuste sugerido' }}</h3>
              <table class="table">
                <thead><tr><th>Data</th><th>Atual</th><th>Proposta</th></tr></thead>
                <tbody>
                  <tr><th>Início</th><td>{{ change.current.sale_start ? (change.current.sale_start | date:'dd/MM/yyyy HH:mm:ss':'-0300') : 'Sem data' }}</td><td>{{ change.proposed.sale_start ? (change.proposed.sale_start | date:'dd/MM/yyyy HH:mm:ss':'-0300') : 'Sem data' }}</td></tr>
                  <tr><th>Término</th><td>{{ change.current.sale_end ? (change.current.sale_end | date:'dd/MM/yyyy HH:mm:ss':'-0300') : 'Sem data' }}</td><td>{{ change.proposed.sale_end ? (change.proposed.sale_end | date:'dd/MM/yyyy HH:mm:ss':'-0300') : 'Sem data' }}</td></tr>
                </tbody>
              </table>
              <p class="mb-0 text-secondary">Período atual: {{ scheduleDuration(change.current) }}. Proposto: {{ scheduleDuration(change.proposed) }}.</p>
            </article>
          }
        </div>
        @if (proposal.blockers.length) {
          <div class="schedule-errors p-3" role="alert">
            <h3 class="h5">Não é possível aplicar este ajuste</h3>
            @for (blocker of proposal.blockers; track $index) { <p class="mb-1">{{ blocker }}</p> }
          </div>
        } @else if (proposal.token && !proposal.errors.length) {
          <p class="mt-3">Ao confirmar, salvaremos este lote e os ajustes mostrados juntos. Preços e estoques dos lotes seguintes não serão alterados.</p>
        }
      </section>
    } @else {
    <form [formGroup]="batchForm" (ngSubmit)="saveBatch()" [attr.inert]="isSaving ? '' : null">
      <div class="d-flex flex-column justify-content-between p-3">
        <div>
          <p class="h4 title">{{ sectionTitle }}</p>
          <p class="p text-secondary">{{ sectionDescription }}</p>
          @if (hasPaidSales) {
            <p class="p text-secondary">Este lote já tem vendas. Você pode adiar o término dentro do limite de vendas do lote. Se afetar os próximos lotes, mostraremos uma sugestão para você confirmar. O início e as demais configurações ficam bloqueados.</p>
          }
          @if (selectedBatch?.id) {
            <p class="p text-secondary">Todos os ingressos seguem as datas e a regra de virada deste lote.</p>
          }
          @if (!availabilityMode) {
            <div class="mb-3">
              <label class="form-label" for="lotType">Tipo do lote</label>
              <select id="lotType" class="form-select" [value]="lotType" [disabled]="hasPaidSales || closedBatch || isSaving" (change)="onLotTypeChange($event)">
                <option value="advance" [disabled]="advanceUnavailable && isPortaria">Antecipado</option>
                <option value="portaria">Portaria</option>
              </select>
              <p class="p text-secondary mt-1">
                {{ isPortaria
                  ? 'Venda durante o evento, somente no PDV. Cadastre ingressos, preços e estoque próprios para este lote.'
                  : 'Venda antes do evento, online e, se habilitado, no PDV antecipado. O término não pode ultrapassar o início do evento.' }}
              </p>
            </div>
          }
          @if (salesClosingLimit && !soldOutOnly) {
            <p class="p text-secondary">{{ isPortaria ? 'Limite de término da portaria' : 'Limite de término online' }}: {{ salesClosingLimit | date:'dd/MM/yyyy HH:mm' }}.</p>
          }
          @if (closedBatch) {
            <p class="text-danger">Este lote já foi encerrado e não pode ser reaberto.</p>
          }
        </div>

        @if (!availabilityMode) {

          <div class="mb-3">
            <label for="transitionMode" class="form-label">Virada do lote</label>
            <select id="transitionMode" class="form-select" formControlName="transitionMode">
              <option value="date_or_sold_out">Por data ou esgotamento</option>
              <option value="sold_out_only" [disabled]="isPortaria && hasPredecessor">Somente por esgotamento</option>
            </select>
            <p class="p text-secondary mt-1">
              {{
                soldOutOnly
                  ? "Sem data de virada. Lotes online vendem até esgotar ou até o início do evento; portaria, no máximo, até o fim do evento."
                  : "Vira na data de término ou ao esgotar, o que ocorrer primeiro."
              }}
            </p>
            @if (soldOutOnly && !openingEditable) {
              <p class="p text-secondary">Aguarda o lote anterior encerrar. A sequência segue a ordem dos lotes.</p>
            }
          </div>
        }

        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="row" formGroupName="ticketsDateGroup">
              @if (openingEditable || hasPaidSales) {
                <div class="col-12 col-lg-6">
                  <div class="form-grid">
                    <label for="startDateTime" class="form-label">Data e Hora Início</label>
                    <p-datePicker
                      appDatepickerMask
                      id="startDateTime"
                      formControlName="startDateTime"
                      (onSelect)="onCalendarSelect('startDateTime', $event)"
                      (onInput)="onCalendarInput('startDateTime', $event)"
                      dateFormat="dd/mm/yy"
                      inputStyleClass="w-100"
                      panelStyleClass="event-sales-calendar"
                      class="w-100"
                      [showTime]="true"
                      [hourFormat]="'24'"
                      [showIcon]="true"
                      [appendTo]="'body'"
                      [iconDisplay]="'input'"
                      [selectOtherMonths]="true"
                      [minDate]="openingMinimum"
                      [maxDate]="openingLimit"
                      class="w-100"
                      [class.ng-dirty]="batchForm.controls.ticketsDateGroup.controls.startDateTime.dirty"
                      [class.ng-invalid]="
                        batchForm.controls.ticketsDateGroup.controls.startDateTime.touched &&
                        batchForm.controls.ticketsDateGroup.controls.startDateTime.invalid
                      " />

                    @if (
                      batchForm.controls.ticketsDateGroup.controls.startDateTime.touched &&
                      batchForm.controls.ticketsDateGroup.controls.startDateTime.hasError("required")
                    ) {
                      <div class="invalid-feedback">Data de início é obrigatória.</div>
                    }
                  </div>
                </div>
              }

              @if (!soldOutOnly) {
                <div class="col-12 col-lg-6">
                  <div class="form-grid">
                    <label for="endDateTime" class="form-label">Data e Hora Término</label>
                    <p-datePicker
                      appDatepickerMask
                      id="endDateTime"
                      [maxDate]="salesClosingLimit"
                      formControlName="endDateTime"
                      (onSelect)="onCalendarSelect('endDateTime', $event)"
                      (onInput)="onCalendarInput('endDateTime', $event)"
                      dateFormat="dd/mm/yy"
                      inputStyleClass="w-100"
                      panelStyleClass="event-sales-calendar"
                      class="w-100"
                      [showTime]="true"
                      [hourFormat]="'24'"
                      [showIcon]="true"
                      [appendTo]="'body'"
                      [iconDisplay]="'input'"
                      [selectOtherMonths]="true"
                      [minDate]="closingMinimum"
                      class="w-100"
                      [class.ng-dirty]="batchForm.controls.ticketsDateGroup.controls.endDateTime.dirty"
                      [class.ng-invalid]="
                        batchForm.controls.ticketsDateGroup.controls.endDateTime.touched &&
                        batchForm.controls.ticketsDateGroup.controls.endDateTime.invalid
                      " />

                    @if (
                      batchForm.controls.ticketsDateGroup.controls.endDateTime.touched &&
                      batchForm.controls.ticketsDateGroup.controls.endDateTime.hasError("required")
                    ) {
                      <div class="invalid-feedback">Data de término é obrigatória.</div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- validações gerais (erros do group ticketsDateGroup) -->
        <div class="mt-2">
          @if (batchForm.controls.ticketsDateGroup.touched) {
            @if (batchForm.controls.ticketsDateGroup.hasError("portariaOpeningBeforeEventStart")) {
              <div class="text-danger">O lote de portaria deve começar a partir do início do evento.</div>
            }
            @if (batchForm.controls.ticketsDateGroup.hasError("advanceOpeningAtOrAfterEventStart")) {
              <div class="text-danger">O lote antecipado deve começar antes do evento. Para vender durante o evento, escolha Portaria.</div>
            }
            @if (batchForm.controls.ticketsDateGroup.hasError("openingLockedAfterSales")) {
              <div class="text-danger">O início das vendas não pode ser alterado após a primeira venda paga.</div>
            }
            @if (batchForm.controls.ticketsDateGroup.hasError("onlyCurrentBatchCanPostpone")) {
              <div class="text-danger">Somente o lote atual, ainda aberto, pode ser adiado.</div>
            }
            @if (batchForm.controls.ticketsDateGroup.hasError("closingMustBePostponed")) {
              <div class="text-danger">O novo término deve ser posterior ao término atual.</div>
            }
          }
          @if (batchForm.controls.ticketsDateGroup.hasError("closingAfterEventStart")) {
            <div class="text-danger">O término das vendas online deve ser no máximo até o início do evento.</div>
          }
          @if (
            batchForm.get("ticketsDateGroup")?.errors?.["dateBeforeCurrent"] &&
            batchForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">
              As datas de início e/ou término da venda de ingressos não podem ser antes da data atual.
            </div>
          }

          @if (
            batchForm.get("ticketsDateGroup")?.errors?.["dateEndBeforeStart"] &&
            batchForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">A data de término não pode ser antes da data de início.</div>
          }

          @if (
            batchForm.get("ticketsDateGroup")?.errors?.["startDateAfterEventEnd"] &&
            batchForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">A venda de ingressos deve começar antes do término do evento.</div>
          }

          @if (
            batchForm.get("ticketsDateGroup")?.errors?.["endDateAfterEventEnd"] &&
            batchForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">
              A data de término da venda de ingressos não pode ser após o término do evento.
            </div>
          }

          @if (
            batchForm.get("ticketsDateGroup")?.errors?.["datesAreEqual"] && batchForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">As datas das vendas de ingressos não podem ser iguais.</div>
          }

          @if (
            batchForm.get("ticketsDateGroup")?.errors?.["batchDateOverlapsAnotherBatch"] &&
            batchForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">
              @if (selectedBatch?.id) {
                O período interfere em outro lote. Clique em Salvar para comparar as datas e revisar uma sugestão de ajuste.
              } @else {
                O período deste lote está sobrepondo o período de outro lote. Ajuste as datas.
              }
            </div>
          }
        </div>

        @if (!availabilityMode) {
          <div class="batch-options mt-3">
            <p class="batch-options__heading">Taxas e canais de venda</p>

            @if (isPortaria) {
              <p class="p text-secondary p-3 mb-0">Venda exclusiva no PDV Evento. As taxas de plataforma e de processamento são absorvidas pelo produtor, sem acréscimo ao cliente.</p>
            }

            <div class="batch-options__grid">
            @if (!isPortaria) {
            <div class="batch-options__item">
              <div>
                <label class="batch-options__title" for="absorbPlatformFeeBatch"> Absorver taxa da plataforma </label>
                <p class="batch-options__description">
                  O produtor absorve a taxa da plataforma, sem acrescentá-la ao preço pago pelo cliente.
                </p>
              </div>
              <div class="form-check form-switch m-0">
                <input
                  id="absorbPlatformFeeBatch"
                  class="form-check-input batch-options__switch"
                  type="checkbox"
                  role="switch"
                  formControlName="absorbsPlatformFee" />
              </div>
            </div>

            <div class="batch-options__item">
              <div>
                <label class="batch-options__title" for="absorbProcessingFeeBatch">
                  Absorver taxa de processamento
                </label>
                <p class="batch-options__description">
                  O produtor assume a taxa cobrada pelo processamento do pagamento.
                </p>
              </div>
              <div class="form-check form-switch m-0">
                <input
                  id="absorbProcessingFeeBatch"
                  class="form-check-input batch-options__switch"
                  type="checkbox"
                  role="switch"
                  formControlName="absorbsProcessingFee" />
              </div>
            </div>

            <div class="batch-options__item">
              <div>
                <label class="batch-options__title" for="soldAtPdvBatch">Permitir venda antecipada no PDV</label>
                <p class="batch-options__description">
                  Disponibiliza os ingressos deste lote no PDV antes do início do evento.
                  No PDV antecipado, 10% de plataforma são acrescentados ao ingresso. Na portaria, 5% são absorvidos
                  pelo produtor. No PDV não há taxa de processamento, inclusive no dinheiro.
                  As opções de absorção acima se aplicam às vendas online.
                </p>
              </div>
              <div class="form-check form-switch m-0">
                <input
                  id="soldAtPdvBatch"
                  class="form-check-input batch-options__switch"
                  type="checkbox"
                  role="switch"
                  formControlName="soldAtPdv" />
              </div>
            </div>
            }
            <div class="batch-options__item">
              <div>
                <label class="batch-options__title" for="hasHalfPriceBatch">Meia-entrada</label>
                <p class="batch-options__description">
                  Duplica todos os ingressos deste lote como meia-entrada, com preço e quantidade próprios. Na compra, o
                  cliente vê as regras (CIE, CIPTEA/autismo, PCD, idoso e CadÚnico).
                </p>
              </div>
              <div class="form-check form-switch m-0">
                <input
                  id="hasHalfPriceBatch"
                  class="form-check-input batch-options__switch"
                  type="checkbox"
                  role="switch"
                  formControlName="hasHalfPrice" />
              </div>
            </div>
            </div>
          </div>
        }
      </div>
    </form>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  @if (proposal) {
    <app-button styleType="secondary" [disabled]="isSaving" (click)="backToDates()">Voltar às datas</app-button>
    <app-button [loading]="isSaving" [disabled]="isSaving || !proposal.token || !!proposal.blockers.length || !!proposal.errors.length" (click)="confirmSchedule()">Confirmar e salvar ajustes</app-button>
  } @else {
    <app-button styleType="secondary" [disabled]="isSaving" (click)="closeModal()">Cancelar</app-button>
    <app-button type="submit" [loading]="isSaving" [disabled]="isSaving || closedBatch" (click)="saveBatch()">Salvar</app-button>
  }
</mat-dialog-actions>
